class classBtn {
    constructor(disabled = true, visible = false, show = true) {
        this.disabled = disabled;
        this.visible = visible;
        this.show = show;
    }
};

export default classBtn;